import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const DefaultError = () => (
  <BaseErrorDisplay
    title="There's a problem with the system."
    subtitle="SIGNIN ERROR"
    description="There could be a misconfiguration in the system or a service outage. We track these errors automatically, but if the problem persists feel free to contact us. Please try again."
    imgSrc={infoSvg}
  />
)
